import React, { memo } from 'react'
import EmptyRecommendations from 'assets/illustrations/RecommendationsIllustration.svg'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { RECOMMENDED_SHIPMENTS_TEST_IDS } from '../../constants'

const useRecommendedShipmentsSectionEmptyStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(4)} 0`,
  },
  illustration: {
    marginBottom: theme.spacing(1),
  },
  title: {
    marginBottom: theme.spacing(1),
  },
}))

export interface IRecommendedShipmentsSectionEmptyProps {}

const RecommendedShipmentsSectionEmpty = memo<IRecommendedShipmentsSectionEmptyProps>(() => {
  const classes = useRecommendedShipmentsSectionEmptyStyles()
  return (
    <div className={classes.root} data-test={RECOMMENDED_SHIPMENTS_TEST_IDS.emptyState}>
      <div className={classes.illustration}>
        <img src={EmptyRecommendations} alt='EmptyRecommendations' />
      </div>
      <div className={classes.title}>
        <Typography variant='subtitle1'>No suggested loads yet</Typography>
      </div>
      <Typography variant='body2' align='center'>
        Find & book your first load to see suggested loads for you.
      </Typography>
    </div>
  )
})

export default RecommendedShipmentsSectionEmpty
